import { gql } from '@apollo/client';

export const CONTACT_US_MUTATION = gql`
  mutation ContactUs($contactUsContactUsInput2: ContactUsInput!) {
    contactUs(contactUsInput: $contactUsContactUsInput2) {
      message
    }
  }
`;
